<div class="loading-container" [class.fullscreen]="fullScreen">
  <div class="loading-inner" [ngClass]="'size-' + size">
    <div class="pusli-stage">
      <img
        src="assets/pusula/pusli.png"
        class="pusli-bird"
        alt=""
        role="presentation"
      >
    </div>
  </div>
  <p *ngIf="message" class="loading-message">{{ message }}</p>
</div>
